import { render, staticRenderFns } from "./UgiDropdown.vue?vue&type=template&id=433e85ac&scoped=true&"
import script from "./UgiDropdown.vue?vue&type=script&lang=js&"
export * from "./UgiDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e85ac",
  null
  
)

export default component.exports